// js/helper/currency.js
function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}
// guarded so a missing themeVariables at load time can't crash the whole file
var _tv = (window.themeVariables && window.themeVariables.settings) || {};
let currencyFormat = _tv.currencyCodeEnabled ? _tv.moneyWithCurrencyFormat : _tv.moneyFormat;


// ===================================================================================================================================================


$(document).ready(function () {
  var pInfScrLoading = false;
  var pInfScrDelay   = 100;
  var LOAD_OFFSET    = 400; // px from step-1's bottom at which to pull the next page

  // re-wire Swym swatches / collection UI on freshly appended cards (guarded so it never throws)
  function reinitSwym() {
    if (window._swat && _swat.collectionsApi && typeof _swat.collectionsApi.initializeCollections === 'function') {
      _swat.collectionsApi.initializeCollections(_swat, true, Shopify.theme.schema_name);
    }
  }

  function pInfScrExecute() {
    var $step = $('#step-1');
    if (!$step.length || !$step.hasClass('is-active')) return;

    // only load when within LOAD_OFFSET of step-1's bottom
    var stepBottom   = $step.offset().top + $step.outerHeight();
    var scrollBottom = $(window).scrollTop() + $(window).height();
    if (scrollBottom < stepBottom - LOAD_OFFSET) return;

    var $pagination = $step.find('.m-byob-next-page_link');
    if (!$pagination.length || pInfScrLoading) return;

    var nextUrl = $pagination.find('a').attr('href');
    if (!nextUrl) return;

    pInfScrLoading = true;
    $step.find('.m-byob_item_product_list')
         .append('<img src="https://cdn.shopify.com/s/files/1/0092/3831/5068/files/transparent-loader.gif?v=1751462450" class="m-byob-new-page-loading" alt="">');

    $.ajax({
      type: 'GET',
      url: nextUrl,
      dataType: 'html',
      success: function (data) {
        var $response      = $(data);
        var $newGrid       = $response.find('#step-1 .m-byob_item_product_list-grid');
        var $newPagination = $response.find('#step-1 .m-byob-next-page_link');
        var $newCards      = $newGrid.children();
        var loadedCount    = $newCards.length; // capture before append() moves the nodes

        // drop the old "More" link
        $pagination.remove();

        var $grid = $step.find('.m-byob_item_product_list-grid');
        if (loadedCount)            $grid.append($newCards);
        if ($newPagination.length) $grid.append($newPagination);

        // appended cards need Swym re-init to match the initially-rendered ones
        if (loadedCount) reinitSwym();

        console.log(
          'BYOB infinite scroll — loaded:', nextUrl,
          '| products:', loadedCount,
          '| next:', $newPagination.length ? $newPagination.find('a').attr('href') : 'none'
        );
      },
      error: function (xhr, status, error) {
        // leave the pagination link in place so the next scroll can retry
        console.error('BYOB infinite scroll error:', error);
      },
      complete: function () {
        $step.find('.m-byob-new-page-loading').remove();
        pInfScrLoading = false;
      }
    });
  }

  $(window).on('scroll', function () {
    clearTimeout(window.pInfScrTimeout);
    window.pInfScrTimeout = setTimeout(pInfScrExecute, pInfScrDelay);
  });
});

// ====================================================================================================================
if ($('.m-byob_main').length > 0) {

  function updateNavButtons() {
    var step   = parseInt($('.m-byob_item.is-active').attr('step'), 10);
    var last   = $('.m-byob_item').length;
    var isLast = step >= last;
    // last step: Review needs a full stack; other steps: just the current pick
    var enabled = isLast ? allStepsSelected() : !!$('.preview-for-step-' + step).attr('variant-id');

    // $('.m-byob_preview-bar_button.prev').prop('disabled', step <= 1);
    // $('.m-byob_preview-bar_button.next').prop('disabled', !enabled).text(isLast ? 'Review' : 'Next');
    
    $('.m-byob_preview-bar_button.prev').toggleClass('disabled', step <= 1);
    $('.m-byob_preview-bar_button.next').toggleClass('disabled', !enabled).text(isLast ? 'Review' : 'Next');
  }

  // every step (incl. gift box) must have a product before the result page unlocks
  function allStepsSelected() {
    var ok = true;
    $('.m-byob_preview-bar_item[class*="preview-for-step-"]').each(function () {
      if (!$(this).attr('variant-id')) ok = false;
    });
    return ok;
  }

  // first step still missing a product (0 if none)
  function firstIncompleteStep() {
    var target = 0;
    $('.m-byob_preview-bar_item[class*="preview-for-step-"]').each(function () {
      if (target) return;
      var m = this.className.match(/preview-for-step-(\d+)/);
      if (m && !$(this).attr('variant-id')) target = parseInt(m[1], 10);
    });
    return target;
  }

  // show result page only when the stack is full; otherwise jump to the gap
  function goToResult() {
    if (!allStepsSelected()) {
      var s = firstIncompleteStep();
      if (s) goToStep(s);
      return;
    }
    $('.m-byob_item').hide();
    $('.m-byob_preview-bar').hide();
    $('.m-byob_result').show();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // single-select buttons for a step. $card present = mark it, absent = reset all
  function setStepButtons(step, $card) {
    var $step = $('.m-byob_item[step="' + step + '"]');

    $step.find('.byob-product-card').removeClass('added');
    $step.find('.m-byob-product-card__quick-add-button').text('Add to Box');
    $step.find('.m-byob-product-card__quick-remove-button').hide();

    if ($card && $card.length) {
      $card.addClass('added');
      $card.find('.m-byob-product-card__quick-add-button').text('Added to Box');
      $card.find('.m-byob-product-card__quick-remove-button').show();
    }
  }

  // reusable — call from anywhere in the parent
  function goToStep(step) {
    step = parseInt(step, 10);
    if (!step || step < 1 || step > $('.m-byob_item').length) return;

    $('.m-byob_item').removeClass('is-active');
    $('.m-byob_item[step="' + step + '"]').addClass('is-active');

    $('.m-byob_slide').removeClass('active');
    $('.m-byob_slide[step="' + step + '"]').addClass('active');

    window.scrollTo({ top: 0, behavior: 'smooth' });
    updateNavButtons();
  }

  // gift box step: show selected-category cards only when step-1's category is in
  // the block's list; otherwise show other-category. Drops a pick that just got hidden.
  function syncGiftBoxStep() {
    var cat = ($('.preview-for-step-1').attr('category') || '').trim().toLowerCase();

    $('.byob-giftbox-grid').each(function () {
      var $grid = $(this);
      var list  = ($grid.attr('selected-categories') || '').toLowerCase()
                    .split(/[\n,]/).map(function (s) { return s.trim(); });
      var showSelected = cat !== '' && $.inArray(cat, list) > -1;

      $grid.toggleClass('show-selected', showSelected);

      // if this step already has a pick in the now-hidden group, clear it
      var $picked = $grid.find('.byob-product-card.added');
      if ($picked.length) {
        var pickedGroup  = $picked.closest('[giftbox-group]').attr('giftbox-group');
        var visibleGroup = showSelected ? 'selected' : 'other';
        if (pickedGroup !== visibleGroup) {
          var giftStep = parseInt($grid.closest('.m-byob_item').attr('step'), 10);
          setStepButtons(giftStep);
          updatePreviewItem(giftStep);
          updateResultItem(giftStep);
          updatePrice();
        }
      }
    });
  }

  // prev
  $('body').on('click', '.m-byob_preview-bar_button.prev', function () {
    if ($(this).is(':disabled')) return;
    var step = parseInt($('.m-byob_item.is-active').attr('step'), 10);
    goToStep(step - 1);
  });

  // next / review
  $('body').on('click', '.m-byob_preview-bar_button.next', function () {
    if ($(this).is(':disabled')) return;
     // If disabled, show active tab hint
      if ($(this).hasClass('disabled')) {
        var hint = $('.m-byob_item_header_tabs--item.is-selected').attr('data-hint');
        if (hint) {
          alert(hint);
        }
        return;
      }

    var step = parseInt($('.m-byob_item.is-active').attr('step'), 10);
    var last = $('.m-byob_item').length;

    if (step >= last) {
      goToResult();            // gated: only opens when every step is filled
    } else {
      goToStep(step + 1);
    }
  });

  // click a filled preview tile → jump to that step (only if a product was added)
  $('body').on('click', '.m-byob_preview-bar_item', function () {
    var match = this.className.match(/preview-for-step-(\d+)/);
    if (!match) return;                       // gift-box / non-step tile → ignore
    if (!$(this).attr('variant-id')) return;  // no product added → ignore
    goToStep(parseInt(match[1], 10));
  });

  // header tab → jump to that step, only if it already has a selection
  // $('body').on('click', '.m-byob_item_header_tabs--item', function () {
  //   var step = parseInt($(this).attr('step'), 10);
  //   if (!step) return;
  //   if (!$('.preview-for-step-' + step).attr('variant-id')) return;
  //   goToStep(step);
  // });
  $('body').on('click', '.m-byob_item_header_tabs--item', function() {
    var $this = $(this);
    var step = parseInt($this.attr('step'), 10);
    if (!step) return;
    // Check previous step before allowing navigation
    if (step > 1) {
        var $prevStep = $('.m-byob_item_header_tabs--item[step="' + (step - 1) + '"]');
        if (!$prevStep.hasClass('p-added')) {
            var hint = $this.attr('data-hint');
            if (hint) {
                alert(hint);
            }
            return false;
        }
    }
    // Go directly to the clicked step
    goToStep(step);
  });

  // reusable — recalc totals for sticky bar + result page
  function updatePrice() {
    var total = 0, compare = 0, anyStepSelected = false;

    $('.m-byob_preview-bar_item').each(function () {
      if (!$(this).attr('variant-id')) return;
      var price = parseInt($(this).attr('price'), 10) || 0;
      total   += price;
      compare += parseInt($(this).attr('compare-price'), 10) || price;
    });

    // has the user picked at least one STEP product? (gift box is auto → excluded)
    $('.m-byob_preview-bar_item[class*="preview-for-step-"]').each(function () {
      if ($(this).attr('variant-id')) anyStepSelected = true;
    });
    $('.m-byob_preview-bar_totals').toggle(anyStepSelected);

    // 1. sticky preview bar
    $('.m-byob_preview-bar_price').html(formatMoney(total, currencyFormat));
    $('.m-byob_preview-bar_compare-price').html(formatMoney(compare, currencyFormat)).toggle(compare > total);

    // 2. result page
    $('[bundle-total]').html(formatMoney(total, currencyFormat));
    $('[bundle-compare]').html(formatMoney(compare, currencyFormat)).toggle(compare > total);
    $('[bundle-savings]').html(compare > total ? 'You are saving ' + formatMoney(compare - total, currencyFormat) + ' on this Gift/BYOB.' : '').toggle(compare > total);
  }

  // reusable — add/update a step's sticky preview tile
  function updatePreviewItem(step, $card) {
    var $item = $('.preview-for-step-' + step);
    var has   = !!($card && $card.length);
    var $tab = $('.m-byob_item_header_tabs--item[step="' + step + '"]');

    $item.toggleClass('added', has);
    $('.m-byob_item[step="' + step + '"]').toggleClass('added', has);   // ← add this
    $tab.toggleClass('p-added', has);   // ← add this

    if (has) {
      var image = $card.attr('featured-image') || '';
      $item.attr({
        'product-id':    $card.attr('product-id') || '',
        'variant-id':    $card.attr('variant-id') || '',
        'handle':        $card.attr('handle') || '',
        'title':         $card.attr('product-title') || '',
        'color':         $card.attr('primary-color') || '',
        'price':         $card.attr('product-price') || '',
        'compare-price': $card.attr('product-compare-price') || $card.attr('product-price') || '',
        'category':      $card.attr('primary-category') || '',
        'image':         image
      }).find('.m-byob_preview-bar_item-media').html('<img src="' + image + '" width="42" height="56" alt="">'); 
    } else {
      $item.attr({ 'product-id': '', 'variant-id': '', 'handle': '', 'title': '', 'color': '', 'price': '', 'compare-price': '', 'category': '', 'image': '' })
           .find('.m-byob_preview-bar_item-media').html($item.data('blankmedia') || '');
    }

    updateNavButtons();
  }

  // reusable — fill a step's result-page slot
  function updateResultItem(step, $card) {
    var $slot = $('.result-step-' + step);

    if ($card && $card.length) {
      var image   = $card.attr('featured-image') || '';
      var price   = parseInt($card.attr('product-price'), 10) || 0;
      var compare = parseInt($card.attr('product-compare-price'), 10) || price;
      var free    = (price === 0);
      var color = $card.attr('primary-color') || '';

      $slot.find('.m-byob_result-product_list-grid_item--media').html('<img src="' + image + '" loading="lazy" alt="">');
      $slot.find('.m-byob_result-product_list-grid_item-title').text($card.attr('product-title') || '');
      $slot.find('.m-byob_result-product_list-grid_item-color').text(color ? `Color: ${color}` : '');
      $slot.find('[result-item-price]').html(formatMoney(price, currencyFormat)).toggle(!free);
      $slot.find('[result-item-compare]').html(formatMoney(compare, currencyFormat)).toggle(!free && compare > price);
      $slot.find('[result-item-savings]').html(!free && compare > price ? `${Math.round((compare - price) / compare * 100)}% OFF` : '').toggle(!free && compare > price);
      $slot.show();
    } else {
      $slot.hide();
    }
  }

  $('body').on('click', '.m-byob-product-card__quick-add-button', function (e) {
    e.preventDefault();

    var $card = $(this).closest('product-card');
    var step  = parseInt($(this).closest('.m-byob_item').attr('step'), 10);
    var last  = $('.m-byob_item').length;

    setStepButtons(step, $card);        // button state
    updatePreviewItem(step, $card);     // sticky tile (+ nav)
    updateResultItem(step, $card);      // result slot

    updatePrice();
    if (step === 1) syncGiftBoxStep();

    if (step < last) {
      goToStep(step + 1);               // auto-advance to next step
    } else {
      goToResult();                     // gated: falls back to the first empty step
    }
  });

  $('body').on('click', '.byob-product-card .thumbnail-swatch', function(e) {
    var _this = this;
    e.preventDefault();
    var product_handle = $(this).attr("product_handle");

    // BYOB: which step is this swatch in? (only if inside the BYOB section)
    var $byobStep = $(this).closest('.m-byob_item');
    var byobStep  = $byobStep.length ? parseInt($byobStep.attr('step'), 10) : 0;

    $(_this).parents(".product-card_main").addClass('loading');
    $.ajax({
      type: 'GET',
      url: `/products/${product_handle}?view=byob-product-card`,
      success: function(data) {
        $(_this).parents(".product-card_main").removeClass('loading');
        $(_this).parents(".product-card_main").html($(data).html());
        _swat.collectionsApi.initializeCollections(_swat, true, Shopify.theme.schema_name);

        // BYOB: the colour changed, so drop this step's current selection
        if (byobStep) {
          setStepButtons(byobStep);
          updatePreviewItem(byobStep);   // no $card → clears tile + nav
          updateResultItem(byobStep);    // no $card → hides result slot

          updatePrice();
          if (byobStep === 1) syncGiftBoxStep();
        }
      },
      error: function(xhr, status, error) {
        $(_this).parents(".product-card_main").removeClass('loading');
        console.error('AJAX error:', status, error);
      }
    });
  });

  $('body').on('click', '.m-byob-product-card__quick-remove-button', function (e) {
    e.preventDefault();

    var step = parseInt($(this).closest('.m-byob_item').attr('step'), 10);

    setStepButtons(step);        // reset all buttons in step
    updatePreviewItem(step);     // clear tile (+ nav)
    updateResultItem(step);      // hide result slot

    updatePrice();
    if (step === 1) syncGiftBoxStep();
  });

  $('body').on('click', '.m-byob_result-product_list-grid_item-edit', function () {
    var step = parseInt($(this).attr('edit-step'), 10) || 1;

    // hide summary, show the builder + sticky bar again
    $('.m-byob_result').hide();
    $('.m-byob_item').css('display', '');
    $('.m-byob_preview-bar').show();

    goToStep(step);
  });

  $('body').on('click', '.m-byob_result--revert', function () {
    // clear every step (tile + result slot + buttons)
    $('.m-byob_item').each(function () {
      var step = parseInt($(this).attr('step'), 10);
      setStepButtons(step);      // reset buttons
      updatePreviewItem(step);   // clear sticky tile (+ nav)
      updateResultItem(step);    // hide result slot
    });

    updatePrice();
    syncGiftBoxStep();

    // back to the builder, step 1
    $('.m-byob_result').hide();
    $('.m-byob_item').css('display', '');
    $('.m-byob_preview-bar').show();
    goToStep(1);
  });

  $('body').on('click', '.m-byob_result--totals-box_cta', function () {
    var $button = $(this);
    if ($button.attr('aria-busy') === 'true') return;
    $button.attr('aria-busy', 'true');

    var qty = 1;
    var bundleId = 'bundle_' + Date.now();
    var bundleNumber = 1;
    var $existing = $('.line-item.hasproperties').first();
    if ($existing.length) bundleNumber = parseInt($existing.attr('data-itemnumber'), 10) + 1;

    var mainVid = $('.preview-for-step-1').attr('variant-id');
    if (!mainVid) { console.error('BYOB: no step-1 product'); $button.removeAttr('aria-busy'); return; }

    var mainProps = { _type: 'byob', _personalize: 'main', _bundleid: bundleId, _mainqty: qty, _bundle_number: bundleNumber };
    var subProps  = { _personalize: 'sub',  _bundleid: bundleId, _mainqty: qty, _bundle_number: bundleNumber };

    var items = [{ id: mainVid, quantity: qty, properties: mainProps }];

    // other steps
    $('.m-byob_preview-bar_item[class*="preview-for-step-"]').each(function () {
      var $item = $(this);
      if ($item.hasClass('preview-for-step-1')) return;
      var vid = $item.attr('variant-id');
      if (!vid) return;

      var key = $item.attr('property-key'), val = $item.attr('title');
      if (key && val) mainProps[key] = val;

      items.push({ id: vid, quantity: qty, parent_id: mainVid, properties: $.extend({}, subProps) });
    });

    items[0].properties = mainProps;

    console.log('items',items);

    // ask the theme which sections to bundle back (gives the correct section IDs)
    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true, detail: { sections: sectionsToBundle }
    }));

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: sectionsToBundle.join(',') })
    })
    .then(function (r) { return r.json(); })
    .then(function (added) {
      return fetch(Shopify.routes.root + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          cart.sections = added.sections;   // carry the correct-keyed sections onto the cart
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: cart }
          }));
          $button.removeAttr('aria-busy');
        });
    })
    .catch(function (err) {
      console.error('BYOB cart error:', err);
      $button.removeAttr('aria-busy');
    });
  });

  // initial state → hide the totals until a step product is chosen
  updatePrice();
  syncGiftBoxStep();
}
// ============================================================
// BYOB — SERVER-SIDE filter/sort for STEP 1 (page collection)
// Step 1 reads the page's `collection`, so we re-render the BYOB
// section against the filtered URL and swap ONLY step-1's grid /
// drawer facets / active facets. Avoids the theme's whole-section
// handler (assumes standard markup, throws here) and leaves the
// rest of the builder state untouched.
// ============================================================
(function () {
  'use strict';

  var sectionId = null;
  var abortCtrl = null;

  function byobSectionId() {
    if (sectionId) return sectionId;
    var host = document.querySelector('.m-byob_main');
    host = host && host.closest('.shopify-section');
    sectionId = host ? host.id.replace('shopify-section-', '') : null;
    return sectionId;
  }

    function isStep1(target) {
    return !!(target && target.closest &&
      target.closest('#byob-step1-facets-drawer, #byob-step1-sort-popover, #byob-step1-active-facets'));
  }

  // ---- Sort for non-step-1 steps (client-side reorder) ----
  // Tag original DOM order once so featured / best-selling can restore it.
  $('[data-byob-srv-grid]').each(function () {
    $(this).children().each(function (i) { this.setAttribute('data-byob-orig-index', i); });
  });

  function byobSrvSortPopover(target) {
    return target && target.closest && target.closest('[id^="byob-srv-sort-popover-"]');
  }

  function byobCardVal($card, attr) {
    var $c = $card.is('.byob-product-card') ? $card : $card.find('.byob-product-card').first();
    return $c.attr(attr);
  }
  function byobCardPrice($card) { return parseInt(byobCardVal($card, 'product-price'), 10) || 0; }
  function byobCardTitle($card) { return (byobCardVal($card, 'product-title') || '').toLowerCase(); }

  function byobSortSrvGrid(index, sortValue) {
    var $grid = $('#byob-srv-grid-' + index);
    if (!$grid.length) return;

    var cards = $grid.children().toArray();

    cards.sort(function (a, b) {
      var $a = $(a), $b = $(b);
      switch (sortValue) {
        case 'price-ascending':  return byobCardPrice($a) - byobCardPrice($b);
        case 'price-descending': return byobCardPrice($b) - byobCardPrice($a);
        case 'title-ascending':  return byobCardTitle($a).localeCompare(byobCardTitle($b));
        case 'title-descending': return byobCardTitle($b).localeCompare(byobCardTitle($a));
        default: // manual / best-selling / created / relevance → restore original order
          return (parseInt(a.getAttribute('data-byob-orig-index'), 10) || 0) -
                 (parseInt(b.getAttribute('data-byob-orig-index'), 10) || 0);
      }
    });

    $grid.append(cards);
  }

  document.addEventListener('facet:update', function (event) {
    // non-step-1 sort popovers → client-side reorder, block theme's section re-render
    var srvPopover = byobSrvSortPopover(event.target);
    if (srvPopover) {
      event.stopImmediatePropagation();
      var idx = srvPopover.id.replace('byob-srv-sort-popover-', '');
      var srvSort = '';
      try {
        var su = event.detail.url instanceof URL ? event.detail.url : new URL(event.detail.url, location.origin);
        srvSort = su.searchParams.get('sort_by') || '';
      } catch (e) {}
      byobSortSrvGrid(idx, srvSort);
      return;
    }

    if (!isStep1(event.target)) return;
    event.stopImmediatePropagation(); // block the theme's global handler

    var sid = byobSectionId();
    if (!sid) return;

    var url = new URL(event.detail.url instanceof URL ? event.detail.url : new URL(event.detail.url, location.origin));
    url.searchParams.set('section_id', sid);

    var pretty = new URL(url); pretty.searchParams.delete('section_id');
    history.replaceState({}, '', pretty.toString());

    if (abortCtrl) abortCtrl.abort();
    abortCtrl = new AbortController();

    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    fetch(url.toString(), { signal: abortCtrl.signal })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var swap = function (sel, mode) {
          var next = doc.querySelector(sel), cur = document.querySelector(sel);
          if (!next || !cur) return;
          if (mode === 'replace') cur.replaceWith(document.importNode(next, true));
          else cur.replaceChildren.apply(cur, document.importNode(next, true).childNodes);
        };

        swap('#byob-step1-grid', 'children');
        swap('#byob-step1-facets-drawer facets-form', 'replace');
        swap('#byob-step1-active-facets', 'children');

        var nc = doc.querySelector('#step-1 .collection-toolbar__products-count--main');
        var cc = document.querySelector('#step-1 .collection-toolbar__products-count--main');
        if (nc && cc) cc.textContent = nc.textContent;

        if (window._swat && _swat.collectionsApi && typeof _swat.collectionsApi.initializeCollections === 'function') {
          _swat.collectionsApi.initializeCollections(_swat, true, Shopify.theme.schema_name);
        }

        if (window.jQuery) {
          var $s = jQuery('#step-1 .byob-search__input');
          if ($s.length) {
            $s.val('');
            jQuery('#step-1 .byob-product-card_main').show();
            jQuery('#step-1 .m-byob_item_no-result').hide();

            jQuery('#step-1 .collection-toolbar__products-count--main').show();
            jQuery('#step-1 .collection-toolbar__search-products-count--main').hide();
          }
        }
      })
      .catch(function (e) { if (e.name !== 'AbortError') console.error(e); })
      .finally(function () {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      });
  }, true);
})();

// ==============================================================
$('.byob-search__input').on('input', function () {
  const $input = $(this);
  const rawValue = $.trim($input.val());
  const searchValue = rawValue.toLowerCase();
  const $step = $input.closest('.m-byob_item');

  let resultCount = 0;

  $step.find('.byob-product-card_main').each(function () {
    const $wrapper = $(this);
    const productTitle = ($wrapper.find('.byob-product-card').attr('product-title') || '').toLowerCase();
    const isMatch = !searchValue || productTitle.includes(searchValue);
    $wrapper.toggle(isMatch);
    if (isMatch) resultCount++;
  });

  const $defaultCount = $step.find('.collection-toolbar__products-count--main');
  const $resultsCount = $step.find('.collection-toolbar__search-products-count--main');

  if (searchValue) {
    $defaultCount.hide();
    $resultsCount.text(resultCount + ' results found for "' + rawValue + '"').show();
  } else {
    $resultsCount.hide().text('');
    $defaultCount.show();
  }

  // Show/hide no-result message
  $step.find('.m-byob_item_no-result').toggle(searchValue !== '' && resultCount === 0);
});